export default {
    path: '/auth-check-order/code-check-order',
    name: 'Code-Check-Order',
    component: () => import('@/views/auth/auth_code_check_order.vue'),
    meta: {
        title: 'Авторизация',
        forVisitors: true
    }
}